/* ------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */


<template>
  <div>
    <div>
      <!--  Status bar, first row -->
      <form
        id="my-groups-form"
        class="form-horizontal"
        :aria-label="(orgType == 'edu') ? 'Manage Classes' : 'Manage Groups'"
      >
        <div
          class="form-group row"
          :aria-label="(isEdu) ? 'View Class Details' : 'View Group Details'"
        >
          <div
            v-if="selectedGroup"
            class="col-xs-12 col-sm-6"
          >
            <!--  Group Selector  -->
            <div class="col-xs-4 groupSelectionCell">
              <div>
                <label
                  for="groupSelector1"
                  class="control-label"
                >
                  Group
                </label>
              </div>
              <div>
                <select
                  id="groupSelector1"
                  v-model="selectedGroup"
                  class="form-control"
                >
                  <option
                    v-for="group in managedGroups"
                    :value="group"
                  >
                    {{ group.name }}
                  </option>
                </select>
              </div>
            </div>
            <!--  Group Invite Code  -->
            <div
              v-if="selectedGroup && selectedGroup.inviteCode"
              class="col-xs-4 groupInfoCell"
            >
              <div>
                <label
                  for="groupCode"
                  class="control-label"
                >
                  <span class="theWordGroup">
                    Group
                  </span>
                  Invite Code
                </label>
              </div>
              <div>
                <input
                  id="groupCode"
                  class="form-control"
                  type="text"
                  :value="selectedGroup.inviteCode"
                  readonly
                  onclick="this.select();"
                >
              </div>
            </div>
            <!--  Group Invite Link  -->
            <div
              v-if="selectedGroup && selectedGroup.inviteLink"
              class="col-xs-4 groupInfoCell"
            >
              <div>
                <label
                  for="groupLink"
                  class="control-label"
                >
                  <span class="theWordGroup">
                    Group
                  </span>
                  Invite Link
                </label>
              </div>
              <div>
                <input
                  id="groupLink"
                  class="form-control"
                  type="text"
                  :value="selectedGroup.inviteLink"
                  readonly
                  onclick="this.select();"
                >
              </div>
            </div>
          </div>

          <!--  Button Group  -->
          <div
            class="col-xs-12 col-sm-6 justify-content-right"
            style="margin-top: 27px;"
          >
            <!--  Create Assignment Button  -->
            <button
              v-if="selectedGroup"
              class="btn btn-primary"
              @click.self.prevent="$router.replace({name: 'create-assignment'});"
            >
              Create Assignment
            </button>

            <!--  Create New Group Button  -->
            <button
              v-if="isOrgLevelManager"
              class="btn clear-btn"
              @click.self.prevent="creatingNewGroup = !creatingNewGroup"
            >
              Create New Group
            </button>

            <button
              v-if="selectedGroup"
              class="btn clear-btn"
              @click.self.prevent="$router.push({name: 'reorder-assignments', params: {groupId: selectedGroup.groupId }})"
            >
              Reorder Assignments
            </button>

            <!--  Wordspotting Button  -->
            <router-link
              v-if="showWordspotting"
              :to="{ name: 'wordspotting' }"
            >
              <button
                class="btn clear-btn"
              >
                Wordspotting
              </button>
            </router-link>
          </div>
        </div>

        <!--  Create New Group inputs  -->
        <div
          v-if="creatingNewGroup"
          id="create-new-group"
          class="form-group row"
          aria-label="Add Group Form"
        >
          <!--  spacer to cause inputs to align under group of buttons on wide displays  -->
          <div class="hidden-xs col-sm-6">
            &nbsp;
          </div>
          <div
            class="col-xs-12 col-sm-6"
            style="padding-left: 176px"
          >
            <label for="newGroup">
              <span>
                Create a New Group
              </span>
            </label>
            <br>
            <input
              id="newGroup"
              v-model="newGroup"
              class="form-control"
              type="text"
              :placeholder="orgType == 'edu' ? 'enter the course/semester/section number' : 'enter the name'"
              @keydown.enter.prevent="addGroup"
            >
            <button
              class="btn btn-primary"
              @click.self.prevent="addGroup"
            >
              Save
            </button>
          </div>
        </div>
      </form>

      <hr>

      <!--  Second row of status bar: assignments/members toggle, stats  -->
      <div
        v-if="managedGroups.length"
        class="row"
      >
        <div
          id="assignments-members-toggler"
          class="col-sm-5"
        >
          <span
            :class="coachDashboardToggle == 'assignments' ? 'coachHead' : 'hoverLink'"
            @click.prevent="toggle('assignments')"
          >
            Assignments
          </span>
          <span class="assignments-members-toggler-divider">
            |
          </span>
          <span
            :class="coachDashboardToggle == 'members' ? 'coachHead' : 'hoverLink'"
            @click.prevent="toggle('members')"
          >
            Members
          </span>
          <span class="assignments-members-toggler-divider">
            |
          </span>
          <span
            :class="coachDashboardToggle == 'templates' ? 'coachHead' : 'hoverLink'"
            @click.prevent="toggle('templates')"
          >
            Templates
          </span>
        </div>
        <div
          v-if="coachDashboardToggle == 'assignments'"
          id="stats"
          class="hidden-xs col-sm-5"
        >
          <div
            v-for="stat in stats"
            :key="stat.name"
            class="stat"
            :class="[ 'col-xs-' + Math.floor(10 / stats.length) ]"
          >
            <div class="stat-value">
              {{ stat.value }}
            </div>
            <div class="stat-name">
              {{ stat.name }}
            </div>
          </div>
        </div>
        <div
          v-if="coachDashboardToggle == 'assignments'"
          class="hidden-xs col-sm-2"
        >
          <!--  Download Report Button  -->
          <a
            v-if="showDownloadReport"
            id="download-report-btn"
            @click.capture.prevent="preDownloadReport()"
          >
            <svg class="svgicon icon-dl-report">
              <use xlink:href="/static/svg-symbols.svg#icon-dl-report" />
            </svg>
            <div>
              Download<br>Report
            </div>
          </a>
        </div>
      </div>

      <!-- Filters -->
      <!--  ASSIGNMENTS  -->
      <div v-if="coachDashboardToggle == 'templates' && managedGroups.length">
        <div v-if="!templates || !templates.length">
          <br>
          Click the Create Assignment button to add a new assignment.
          <br><br><br>
        </div>
        <div
          v-if="templates && templates.length"
          class="row"
        >
          <div
            class="col-sm-3"
          >
            <h2>
              Templates
            </h2>
          </div>
          <div
            id="template-toggler"
            class="col-sm-6"
          >
            <span
              :class="{ coachHead: templateToggle == 'all' }"
              @click.prevent="toggleTemplate('all')"
            >
              All
            </span>
            <span class="assignments-members-toggler-divider">
              |
            </span>
            <span
              :class="{ coachHead: templateToggle == 'shared' }"
              @click.prevent="toggleTemplate('shared')"
            >
              Shared
            </span>
            <span class="assignments-members-toggler-divider">
              |
            </span>
            <span
              :class="{ coachHead: templateToggle == 'private' }"
              @click.prevent="toggleTemplate('private')"
            >
              Private
            </span>
          </div>
        </div>
        <coach-assignments
          v-if="!loading"
          :assignments="filteredTemplates"
        />
        <div
          v-if="!templates && !templates.length"
        >
          No templates found
        </div>
      </div>
      <div v-if="coachDashboardToggle == 'assignments' && managedGroups.length">
        <div
          class="row coachAssignments"
        >
          <div class="col-sm-4">
            <h2>
              {{ selectedGroup ? selectedGroup.name : '' }} Assignments
            </h2>
          </div>
          <div class="col-sm-8 filter">
            <div class="filter">
              |
              <span
                :class="coachAssFilter == 'recent' ? 'active' : 'hoverLink'"
                @click.prevent="loadFilter('coachAss', 'recent')"
              >
                Recent
              </span>
              |
              <span
                :class="coachAssFilter == 'completed' ? 'active' : 'hoverLink'"
                @click.prevent="loadFilter('coachAss', 'completed')"
              >
                Completed
              </span>
              |
              <span
                :class="coachAssFilter == 'active' ? 'active' : 'hoverLink'"
                @click.prevent="loadFilter('coachAss', 'active')"
              >
                Active
              </span>
              |
              <span
                :class="coachAssFilter == 'all' ? 'active' : 'hoverLink'"
                @click.prevent="loadFilter('coachAss', 'all')"
              >
                All
              </span>
              |
            </div>
          </div>
        </div>
        <div
          v-if="!filteredGroupAssignments || !filteredGroupAssignments.length"
        >
          No assignments found
        </div>
        <coach-assignments
          v-else-if="!loading"
          :assignments="filteredGroupAssignments"
        />
      </div>

      <div
        v-if="selectedGroup && coachDashboardToggle == 'members' && managedGroups.length"
        class="row table-controls"
      >
        <div
          class="col-sm-4"
        >
          <h2 class="membersHeader">
            {{ selectedGroup ? selectedGroup.name : '' }} Members
          </h2>
        </div>

        <div
          class="col-sm-4 filter-toggler"
        >
          <div class="filter-label">
            Member Assignment Status
          </div>
          <span
            :class="{ active: getGroupFilter(selectedGroup.groupId, 'assignments') == 'recent' }"
            @click.prevent="setGroupFilter(selectedGroup.groupId, 'assignments', 'recent')"
          >
            Recent
          </span>
          |
          <span
            :class="{ active: getGroupFilter(selectedGroup.groupId, 'assignments') == 'completed' }"
            @click.prevent="setGroupFilter(selectedGroup.groupId, 'assignments', 'completed')"
          >
            Completed
          </span>
          |
          <span
            :class="{ active: getGroupFilter(selectedGroup.groupId, 'assignments') == 'active' }"
            @click.prevent="setGroupFilter(selectedGroup.groupId, 'assignments', 'active')"
          >
            Active
          </span>
          |
          <span
            :class="{ active: getGroupFilter(selectedGroup.groupId, 'assignments') == 'all' }"
            @click.prevent="setGroupFilter(selectedGroup.groupId, 'assignments', 'all')"
          >
            All
          </span>
        </div>
        <div
          class="col-sm-4 filter-toggler"
        >
          <div class="filter-label">
            Recordings
          </div>
          <span
            :class="{ active: getGroupFilter(selectedGroup.groupId, 'recordings') == 'flagged' }"
            @click.prevent="setGroupFilter(selectedGroup.groupId, 'recordings', 'flagged')"
          >
            Flagged for Review
          </span>
          |
          <span
            :class="{ active: getGroupFilter(selectedGroup.groupId, 'recordings') == 'shared' }"
            @click.prevent="setGroupFilter(selectedGroup.groupId, 'recordings', 'shared')"
          >
            Shared
          </span>
          |
          <span
            :class="{ active: getGroupFilter(selectedGroup.groupId, 'recordings') == 'withComments' }"
            @click.prevent="setGroupFilter(selectedGroup.groupId, 'recordings', 'withComments')"
          >
            With Comments
          </span>
          |
          <span
            :class="{ active: getGroupFilter(selectedGroup.groupId, 'recordings') == 'all' }"
            @click.prevent="setGroupFilter(selectedGroup.groupId, 'recordings', 'all')"
          >
            All
          </span>
        </div>
      </div>

      <div v-if="selectedGroup && coachDashboardToggle == 'members' && managedGroups.length">
        <div v-if="!loading && speakers && speakers.length">
          <!--  1st table level: speakers  -->
          <table
            :key="coachMemberKey"
            class="table newTable table-bordered"
          >
            <thead>
              <tr>
                <th
                  scope="col"
                  class="sortable"
                  @click.prevent="sortTable('coachMember', 'name')"
                >
                  Name
                  <svg
                    v-if="coachMemberSort == 'name-d' || coachMemberSort == 'name-u'"
                    class="icon-arrow"
                  >
                    <use :xlink:href="(coachMemberSort == 'name-d') ? '/static/svg-symbols.svg#icon-arrow-down' : '/static/svg-symbols.svg#icon-arrow-up'" />
                  </svg>
                </th>
                <th
                  scope="col"
                  class="sortable"
                  @click.prevent="sortTable('coachMember', 'joinDate')"
                >
                  Join Date
                  <svg
                    v-if="coachMemberSort == 'joinDate-d' || coachMemberSort == 'joinDate-u'"
                    class="icon-arrow"
                  >
                    <use :xlink:href="(coachMemberSort == 'joinDate-d') ? '/static/svg-symbols.svg#icon-arrow-down' : '/static/svg-symbols.svg#icon-arrow-up'" />
                  </svg>
                </th>
                <th
                  scope="col"
                  class="sortable"
                  @click.prevent="sortTable('coachMember', 'lastRecordingDate')"
                >
                  Last Upload
                  <svg
                    v-if="coachMemberSort == 'lastRecordingDate-d' || coachMemberSort == 'lastRecordingDate-u'"
                    class="icon-arrow"
                  >
                    <use :xlink:href="(coachMemberSort == 'lastRecordingDate-d') ? '/static/svg-symbols.svg#icon-arrow-down' : '/static/svg-symbols.svg#icon-arrow-up'" />
                  </svg>
                </th>
                <th
                  scope="col"
                  class="sortable"
                  @click.prevent="sortTable('coachMember', 'assignmentCount')"
                >
                  Total Assignments
                  <svg
                    v-if="coachMemberSort == 'assignmentCount-d' || coachMemberSort == 'assignmentCount-u'"
                    class="icon-arrow"
                  >
                    <use :xlink:href="(coachMemberSort == 'assignmentCount-d') ? '/static/svg-symbols.svg#icon-arrow-down' : '/static/svg-symbols.svg#icon-arrow-up'" />
                  </svg>
                </th>
                <th
                  scope="col"
                  class="sortable"
                  @click.prevent="sortTable('coachMember', 'activeCount')"
                >
                  Active Assignments
                  <svg
                    v-if="coachMemberSort == 'activeCount-d' || coachMemberSort == 'activeCount-u'"
                    class="icon-arrow"
                  >
                    <use :xlink:href="(coachMemberSort == 'activeCount-d') ? '/static/svg-symbols.svg#icon-arrow-down' : '/static/svg-symbols.svg#icon-arrow-up'" />
                  </svg>
                </th>
                <th
                  scope="col"
                  class="sortable"
                  @click.prevent="sortTable('coachMember', 'recordingsCount')"
                >
                  Recordings
                  <svg
                    v-if="coachMemberSort == 'recordingsCount-d' || coachMemberSort == 'recordingsCount-u'"
                    class="icon-arrow"
                  >
                    <use :xlink:href="(coachMemberSort == 'recordingsCount-d') ? '/static/svg-symbols.svg#icon-arrow-down' : '/static/svg-symbols.svg#icon-arrow-up'" />
                  </svg>
                </th>
                <th
                  scope="col"
                  class="sortable"
                  @click.prevent="sortTable('coachMember', 'submittedRecordingsCount')"
                >
                  Recordings Flagged for Review
                  <svg
                    v-if="coachMemberSort == 'submittedRecordingsCount-d' || coachMemberSort == 'submittedRecordingsCount-u'"
                    class="icon-arrow"
                  >
                    <use :xlink:href="(coachMemberSort == 'submittedRecordingsCount-d') ? '/static/svg-symbols.svg#icon-arrow-down' : '/static/svg-symbols.svg#icon-arrow-up'" />
                  </svg>
                </th>
                <th
                  scope="col"
                  class="sortable"
                  @click.prevent="sortTable('coachMember', 'totalFeedback')"
                >
                  Comments
                  <svg
                    v-if="coachMemberSort == 'totalFeedback-d' || coachMemberSort == 'totalFeedback-u'"
                    class="icon-arrow"
                  >
                    <use :xlink:href="(coachMemberSort == 'totalFeedback-d') ? '/static/svg-symbols.svg#icon-arrow-down' : '/static/svg-symbols.svg#icon-arrow-up'" />
                  </svg>
                </th>
              </tr>
            </thead>
            <tbody
              v-for="speaker in speakers"
              :key="speaker.userId"
            >
              <tr :class="getSpeakerClass(speaker)">
                <td scope="row">
                  <a
                    v-if="filterAssignments(speaker.assignments).length > 0"
                    href="#"
                    @click.prevent="expandRow('coachMembersKey', 'coachMembers.members', selectedGroup.groupId + speaker.userId)"
                  >
                    {{ speaker.name }}
                  </a>
                  <span v-else>
                    {{ speaker.name }}
                  </span>
                </td>
                <td>{{ speaker.membershipStartDate | dateShort }}</td>
                <td>{{ speaker.lastRecordingDate | date }}</td>
                <td>{{ speaker.assignments.length }}</td>
                <td>{{ speaker.totalActiveAssignments }}</td>
                <td>{{ speaker.totalRecordings }}</td>
                <td>{{ speaker.totalSubmittedRecordings }}</td>
                <td>{{ speaker.totalFeedback }}</td>
              </tr>
              <tr
                v-if="filterAssignments(speaker.assignments).length > 0"
                v-show="isRowShown('coachMembers.members', selectedGroup.groupId + speaker.userId)"
              >
                <td
                  colspan="8"
                  style="padding-left: 25px"
                >
                  <!--  2nd level table: assignments  -->
                  <table class="table newTable table-condensed table-bordered">
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          class="sortable"
                          @click.prevent="sortTable('coachMemberAss', 'assignmentName')"
                        >
                          Assignment Name
                          <svg
                            v-if="coachMemberSort == 'assignmentName-d' || coachMemberSort == 'assignmentName-u'"
                            class="icon-arrow"
                          >
                            <use :xlink:href="(coachMemberSort == 'assignmentName-d') ? '/static/svg-symbols.svg#icon-arrow-down' : '/static/svg-symbols.svg#icon-arrow-up'" />
                          </svg>
                        </th>
                        <th
                          scope="col"
                          class="sortable"
                          @click.prevent="sortTable('coachMemberAss', 'assignmentDate')"
                        >
                          Assigned Date
                          <svg
                            v-if="coachMemberAssSort == 'assignmentDate-d' || coachMemberAssSort == 'assignmentDate-u'"
                            class="icon-arrow"
                          >
                            <use :xlink:href="(coachMemberAssSort == 'assignmentDate-d') ? '/static/svg-symbols.svg#icon-arrow-down' : '/static/svg-symbols.svg#icon-arrow-up'" />
                          </svg>
                        </th>
                        <th
                          scope="col"
                          class="sortable"
                          @click.prevent="sortTable('coachMemberAss', 'assignmentStatus')"
                        >
                          Speaker Assignment Status
                          <svg
                            v-if="coachMemberAssSort == 'assignmentStatus-d' || coachMemberAssSort == 'assignmentStatus-u'"
                            class="icon-arrow"
                          >
                            <use :xlink:href="(coachMemberAssSort == 'assignmentStatus-d') ? '/static/svg-symbols.svg#icon-arrow-down' : '/static/svg-symbols.svg#icon-arrow-up'" />
                          </svg>
                        </th>
                        <th
                          scope="col"
                          class="sortable"
                          @click.prevent="sortTable('coachMemberAss', 'totalAssRecordings')"
                        >
                          Total Recordings
                          <svg
                            v-if="coachMemberAssSort == 'totalAssRecordings-d' || coachMemberAssSort == 'totalAssRecordings-u'"
                            class="icon-arrow"
                          >
                            <use :xlink:href="(coachMemberAssSort == 'totalAssRecordings-d') ? '/static/svg-symbols.svg#icon-arrow-down' : '/static/svg-symbols.svg#icon-arrow-up'" />
                          </svg>
                        </th>
                        <th
                          scope="col"
                          class="sortable"
                          @click.prevent="sortTable('coachMemberAss', 'submitted')"
                        >
                          Recordings Flagged for Review
                          <svg
                            v-if="coachMemberAssSort == 'submitted-d' || coachMemberAssSort == 'submitted-u'"
                            class="icon-arrow"
                          >
                            <use :xlink:href="(coachMemberAssSort == 'submitted-d') ? '/static/svg-symbols.svg#icon-arrow-down' : '/static/svg-symbols.svg#icon-arrow-up'" />
                          </svg>
                        </th>
                        <th
                          scope="col"
                          class="sortable"
                          @click.prevent="sortTable('coachMemberAss', 'comments')"
                        >
                          Comments
                          <svg
                            v-if="coachMemberAssSort == 'comments-d' || coachMemberAssSort == 'comments-u'"
                            class="icon-arrow"
                          >
                            <use :xlink:href="(coachMemberAssSort == 'comments-d') ? '/static/svg-symbols.svg#icon-arrow-down' : '/static/svg-symbols.svg#icon-arrow-up'" />
                          </svg>
                        </th>
                      </tr>
                    </thead>
                    <tbody
                      v-for="assignment in sortAssignments(filterAssignments(speaker.assignments))"
                      :key="assignment.assignmentId"
                    >
                      <tr
                        :class="getAssignmentClass(assignment)"
                      >
                        <td scope="row">
                          <a
                            v-if="filterRecordings(assignment.recordings).length > 0"
                            href="#"
                            @click.prevent="expandRow('coachMembersKey', 'coachMembers.assignments', selectedGroup.groupId + speaker.userId + assignment.assignmentId)"
                          >
                            {{ assignment.name }}
                          </a>
                          <span v-else>
                            {{ assignment.name }}
                          </span>
                        </td>
                        <td>
                          {{ assignment.createdDate | dateShort }}
                        </td>
                        <td
                          v-if="assignment.completionStatus.status == 'completed'"
                          style="color: #04D97E;"
                        >
                          <svg class="icon-checkmark">
                            <use xlink:href="/static/svg-symbols.svg#icon-checkmark" />
                          </svg> &nbsp;
                          Completed
                        </td>
                        <td
                          v-else-if="assignment.completionStatus.status == 'assigned'"
                          style="color: #D3382F;"
                        >
                          <svg class="icon-eye-slash">
                            <use xlink:href="/static/svg-symbols.svg#icon-eye-slash" />
                          </svg> &nbsp;
                          Not Started
                        </td>
                        <td
                          v-else
                          style="color: #333;"
                        >
                          <svg class="icon-refresh">
                            <use xlink:href="/static/svg-symbols.svg#icon-refresh" />
                          </svg> &nbsp;
                          In Progress
                        </td>
                        <td>
                          {{ assignment.recordings.length }}
                        </td>
                        <td>
                          {{ assignment.numSubmittedRecordings }}
                        </td>
                        <td>
                          {{ assignment.feedbackCount }}
                        </td>
                      </tr>
                      <!--  3rd level is recordings for a given assignment  -->
                      <!--  TODO RDA Does list of recordings need to be filtered to what's been shared with coach?  -->
                      <tr
                        v-if="filterRecordings(assignment.recordings).length > 0"
                        v-show="isRowShown('coachMembers.assignments', selectedGroup.groupId + speaker.userId + assignment.assignmentId)"
                      >
                        <td
                          :colspan="6"
                          style="padding-left: 25px"
                        >
                          <table class="newTable table table-condensed table-bordered">
                            <thead>
                              <tr>
                                <th
                                  v-for="heading in recordingsTableHeadings"
                                  :key="heading.text"
                                  :width="heading.width"
                                  scope="col"
                                >
                                  {{ heading.text.toUpperCase() }}
                                </th>
                              </tr>
                            </thead>
                            <tbody
                              v-for="recording in filterRecordings(assignment.recordings)"
                              :key="recording.id"
                            >
                              <tr>
                                <td
                                  scope="row"
                                  style="padding-left: 25px"
                                >
                                  <router-link
                                    v-if="(currentUserId !== recording.userId) && recording.playbackUrl"
                                    :to="{ name: 'evaluate-recording', params: { recordingId: recording.recordingId } }"
                                  >
                                    {{ recording.title }}
                                  </router-link>
                                  <router-link
                                    v-if="(currentUserId === recording.userId) && recording.playbackUrl"
                                    :to="{ name: 'evaluate-recording', params: { recordingId: recording.recordingId } }"
                                  >
                                    {{ recording.title }}
                                  </router-link>
                                  <span v-if="!recording.playbackUrl">
                                    {{ recording.title }}
                                  </span>
                                </td>
                                <td>
                                  <nobr>{{ recording.createdDate | date }}</nobr>
                                </td>
                                <td>
                                  {{ recording.duration | time }}
                                </td>
                                <td>
                                  {{ recording.overallScore }}
                                </td>
                                <td>
                                  {{ recording.numComments }}
                                </td>
                                <td
                                  v-if="selectedGroup.speakerPrivacyLevel !== 4"
                                  rowspan="2"
                                >
                                  <star-rating
                                    inactive-color="#fff"
                                    :increment="0.5"
                                    :border-width="1"
                                    border-color="#cccccc"
                                    active-color="#EFA042"
                                    :star-size="15"
                                    :rating="_.round(recording.scoreOverallAvgRating/2, 2)"
                                    :read-only="true"
                                    :show-rating="false"
                                  />
                                  (avg of {{ recording.numRatingsscoreOverall }} rating{{ recording.numRatingsscoreOverall == 1 ? '' : 's' }})
                                </td>
                                <td rowspan="2">
                                  <star-rating
                                    inactive-color="#fff"
                                    :increment="0.5"
                                    :border-width="1"
                                    border-color="#cccccc"
                                    active-color="#EFA042"
                                    :star-size="15"
                                    :rating="_.round(recording.scoreOverallAvgRatingCoach/2, 2)"
                                    :read-only="true"
                                    :show-rating="false"
                                  />
                                  (avg of {{ recording.numCoachRatingsscoreOverall }} rating{{ recording.numCoachRatingsscoreOverall == 1 ? '' : 's' }})
                                </td>
                              </tr>
                              <tr>
                                <td
                                  :class="getRecordingClass(recording)"
                                >
                                  <audio
                                    v-if="recording.playbackUrl"
                                    controls
                                  >
                                    <source
                                      :src="recording.playbackUrl"
                                      type="audio/mp3"
                                    >
                                  </audio>
                                </td>
                                <td
                                  :colspan="sharingCellColspan"
                                  :class="getRecordingClass(recording) + ' submissionCell'"
                                >
                                  <div
                                    v-if="recording.submitted"
                                  >
                                    <svg class="icon-flag">
                                      <use xlink:href="/static/svg-symbols.svg#icon-flag" />
                                    </svg>
                                    <strong>
                                      Flagged for coach review on {{ recording.submissionDate | date }}<br>
                                    </strong>
                                  </div>
                                  <div
                                    v-if="recording.feedbackRequested"
                                  >
                                    <svg class="icon-users">
                                      <use xlink:href="/static/svg-symbols.svg#icon-users" />
                                    </svg>
                                    <strong>
                                      Shared with entire group on {{ recording.feedbackRequestedDate | date }}
                                    </strong>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td :colspan="recordingsTableHeadings.length">
                                  <hr style="margin: 4px;">
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else-if="activeGroups && activeGroups.length">
          {{ emptyGroup }}
        </div>
      </div>
    </div>
    <div
      v-if="loading"
      class="text-center"
    >
      <h2>
        <svg
          class="icon-refresh rotate large-spinner"
        >
          <use xlink:href="/static/svg-symbols.svg#icon-refresh" />
        </svg>
        Loading...
      </h2>
    </div>
  </div>
</template>


<style lang="less" scoped>
  @import '../../less/bootstrap-vars.less';
  @import '~bootstrap/less/mixins/buttons.less';
  @media print {
    #my-groups-form, ul.nav-tabs {
      display: none;
    }
    div.tab-well {
      border: 0px;
    }
  }
  input#newGroup {
    width: 255px;
    display: inline;
  }

  hr {
    border-top: 1px solid #ccc;
    margin: 10px 0;
  }

  #my-groups-form .btn {
    font-weight: normal;
    font-size: 10pt;
    margin-bottom: 5px;
  }
  .theWordGroup {
    @media screen and (max-width: 1175px) {
      display: none;
    }
  }

  .submissionCell {
    font-size: 14px;
  }

  .icon-arrow, .icon-users, .icon-flag {
    width: 16px; height: 16px;
    position: relative; top: 2px;
  }

  .icon-checkmark {
    fill: #04D97E;
    position: relative; top: 2px;
    width: 15px; height: 15px;
  }
  .icon-eye-slash {
    fill: #D3382F;
    position: relative; top: 2px;
    width: 15px; height: 15px;
  }
  .icon-refresh {
    position: relative; top: 2px;
    width: 15px; height: 15px;
  }


  /*  This causes the 2 6-column status bar groupings to each take a full row when display width drops below custom breakpoint  */
  #my-groups-form .col-xs-12 {
    @media screen and (max-width: 1175px) {
      width: 100% !important;
    }
  }
  /*  This removes the spacer to the left of the New Group inputs when the button that launched them drops to new row (see rule for .col-xs-12)  */
  #my-groups-form .hidden-xs {
    @media screen and (max-width: 1175px) {
      display: none;
    }
  }

  @media screen and (min-width: 1204px) {
    .justify-content-right {
      text-align: right;
      justify-content: right;
    }
  }

  .groupSelectionCell {
    padding-left: 0 !important;
  }
  .groupSelectionCell, .groupInfoCell {
    padding: 6px 8px;
    label {
      font-size: 10px;
      padding: 0;
      text-transform: uppercase;
    }
    select, input {
      font-size: 14px;
      padding: 3px 6px;
    }
  }

  .filter-label {
    text-transform: uppercase;
    color: #333 !important;
    font-size: 10px;
    font-weight: 400;
  }
  .table-controls {
    margin-bottom: 15px;
  }
  .membersHeader {
    margin-top: 0px 0 0px 0px;
  }
  h2 {
    font-size: 24px;
    margin-top: 0px;
  }

  #download-report-btn {
    color: #5E5E5E;
    font-size: 12px !important;
    text-align: right;
  }
  #download-report-btn:hover {
    cursor: pointer;
    color: darken(#5E5E5E, 20%);
  }
  #download-report-btn div {
    cursor: pointer;
    display: inline-block;
  }
  #download-report-btn .icon-dl-report {
    height: 27px;
    width: 27px;
  }
  #assignments-members-toggler {
    font-size: 18px;
    @media (max-width: 841px) {
      font-size: 16px;
    }
    line-height: 36px;
    color: @link-color;
    cursor: pointer;
    margin-bottom: 10px;
  }
  #template-toggler {
    color: @link-color;
    cursor: pointer;
  }
  #assignments-members-toggler span.active,
  #template-toggler span.active,
  .assignments-members-toggler-divider {
    color: #333;
    cursor: default;
  }

  #stats {
    @media screen and (max-width: 1000px) {
      visibility: hidden;
    }
  }

  #stats .stat {
    display: flex;
    color: #3E3E3E;
    margin-right: 25px;
  }
  #stats .stat-value {
    white-space:nowrap;
    font-size: 24px;
    line-height: 32.68px;
    font-weight: 600;
    margin-right: 3px;
    position: relative;
    bottom: 3px;
  }
  #stats .stat-name {
    font-size: 12px;
    line-height: 16.34px;
    font-weight: 700;
  }
  .filter-toggler {
    color: @link-color;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    label {
      font-weight: bold;
      color: @brand-primary;
    }
  }
  .filter-toggler span.active {
    color: @text-color;
    cursor: default;
  }
  td.submitted, tr.submitted {
    background-color: rgba(67, 183, 241, 0.1);
  }
  .filter span {
    position: relative;
    top: 1px;
    color: @link-color;
    cursor: pointer;
  }
  .filter span.active {
    color: @text-color;
    cursor: default;
  }
  th {
    text-transform: uppercase;
  }
  th.sortable {
    cursor: pointer;
  }
</style>

<script>

import download from 'expose-loader?download!downloadjs/download.js'; // eslint-disable-line no-unused-vars
import BasePage from '../pages/BasePage';
import DownloadReport from '../specials/DownloadReport';
import AssignmentDataStructures from '../specials/AssignmentDataStructures';
import ScorecardMixin from '../specials/ScorecardMixin';
import CoachAssignments from '../layout/CoachAssignments';
import TableMethods from '../specials/TableMethods';
import AssignmentModes from '../specials/AssignmentModes';
import StarRating from 'vue-star-rating';
import CoachDashboardJs from '../specials/CoachDashboardJs';

export default {
  components: {CoachAssignments, StarRating},
  mixins: [BasePage, DownloadReport, AssignmentDataStructures, TableMethods, CoachDashboardJs,
    AssignmentModes, ScorecardMixin],
};
</script>
